import * as axios from 'axios';

import { ConfigurationService } from './ConfigurationService';

export interface AxiosService {}

export class AxiosServiceFactory {
  private configService: ConfigurationService;

  // Instance
  private static internalApiService: axios.AxiosInstance;
  private static externalApiService: axios.AxiosInstance;

  constructor(configService: ConfigurationService) {
    this.configService = configService;
  }

  async createInstance(apiService: 'internal' | 'external'): Promise<axios.AxiosInstance> {
    const internalBaseUrl = this.configService.getWindowOrigin();
    const externalBaseUrl = (await this.configService.getConfigs()).apiUrl;

    if (apiService === 'external')
      return (
        AxiosServiceFactory.externalApiService ||
        (AxiosServiceFactory.externalApiService = this.createAxiosInstance(externalBaseUrl ?? this.configService.getWindowOrigin(), true))
      );

    return (
      AxiosServiceFactory.internalApiService || (AxiosServiceFactory.internalApiService = this.createAxiosInstance(internalBaseUrl, true))
    );
  }

  private createAxiosInstance(baseUrl: string, withCredentials: boolean): axios.AxiosInstance {
    return axios.default.create({
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      baseURL: baseUrl,
      withCredentials: withCredentials,
    });
  }
}
